import React from 'react';
import { II18n, withTranslation } from '@ifit/rapport-webview';
import rapportPackage from './rapport-web.json';
import './index.scss';

export interface IProps {
  i18n: II18n;
  intensity?: number;
}

export const Intensity = ({ intensity = 1, i18n }: IProps) => {
  intensity = Math.abs(intensity);

  let intensityLevel = i18n._translate('Beginner', {
    context:
      'A "beginner" tag implies that a certain workout or series of workouts was made to appeal to the skill level of an inexperienced athlete.',
  });
  if (intensity > 3 && intensity < 6) {
    intensityLevel = i18n._translate('Intermediate', {
      context:
        'An "intermediate" tag implies that a certain workout or series of workouts was made to appeal to the skill level of a mid-level athlete.',
    });
  } else if (intensity >= 6) {
    intensityLevel = i18n._translate('Advanced', {
      context:
        'An "advanced" tag implies that a certain workout or series of workouts was made to appeal to the skill level of an experienced athlete.',
    });
  }

  return (
    <span className="mp-intensity text-intensity text-label">
      {intensityLevel}
    </span>
  );
};

export default withTranslation(rapportPackage)(Intensity);
